export const enqueueMutation = (queue, key, mutation) => {
    const previous = queue.get(key) || Promise.resolve();
    const current = previous
        .catch(() => undefined)
        .then(mutation);

    queue.set(key, current);
    const cleanup = () => {
        if (queue.get(key) === current) {
            queue.delete(key);
        }
    };
    current.then(cleanup, cleanup);

    return current;
};
